import { useEffect, useState } from "react";
import { onAuthStateChanged, User } from "firebase/auth";
import { auth } from "../lib/firebase";

export default function useAuthState() {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        // const token = await currentUser?.getIdToken(true);
        // sessionStorage.setItem("token", token);
        // setUser(currentUser);
        try {
          // Force token refresh to ensure it doesn’t expire
          const token = await currentUser?.getIdToken(true);
          sessionStorage.setItem("token", token);
          setUser(currentUser);
        } catch (error) {
          console.error("Error refreshing token:", error);
          setUser(null);
        }
      } else {
        sessionStorage.removeItem("token")
        setUser(null);
      }
      setLoading(false);
    });

    return () => unsubscribe(); // Cleanup on unmount
  }, []);


  useEffect(() => {
    if (!auth.currentUser?.uid) {
      setLoading(false);
    }
  }, [])

  return { user, loading };
}
